import { View } from '@react-pdf/renderer';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import {
  COLOR_EXTREME,
  COLOR_MODERATE
} from 'features/patient/patient-summary/colors';
import { complexityToAreaMap } from 'lib/documents/critical-areas';
import { useMemo } from 'react';
import { stringifyConcussionComplexity } from '../../../patient-home/components/patient-home-clinician/components/styled-concussion-complexity';
import { PDFCriticalArea } from './pdf-critical-area';
import { BodyText, H3 } from './pdf-default-components';

export function PDFConcussionClassificationAndCriticalAreas(props: {
  patientInfo: PatientInfoState;
}) {
  const criticalAreas = useMemo(
    () => complexityToAreaMap[props.patientInfo.concussion!.subtype],
    [props.patientInfo]
  );

  return (
    <View
      style={{
        gap: 6
      }}
    >
      <View>
        <BodyText>
          Concussion subtype:{' '}
          {stringifyConcussionComplexity(props.patientInfo.concussion!.subtype)}
        </BodyText>
      </View>
      <View style={{ gap: 6 }}>
        <View>
          <H3>Critical Areas</H3>
          <BodyText>
            {`Critical areas that were identified from the test-taker's reports.`}
          </BodyText>
        </View>
        <View
          style={{
            gap: 6
          }}
        >
          <View style={{ width: '100%' }}>
            <PDFCriticalArea
              label="High"
              color={COLOR_EXTREME}
              areas={criticalAreas.high}
            />
          </View>
          <View
            style={{
              width: '100%'
            }}
          >
            <PDFCriticalArea
              label="Medium"
              areas={criticalAreas.medium}
              color={COLOR_MODERATE}
            />
          </View>
        </View>
      </View>
    </View>
  );
}
